module.exports = __webpack_public_path__ + "img/logo-2.658ee78c.png";